import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-five',
  templateUrl: './header-five.component.html',
  styleUrls: ['./header-five.component.scss']
})
export class HeaderFiveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
